import { RegvarBooleanModel } from './RegvarBooleanModel';
import { RegvarDatetimeModel } from './RegvarDatetimeModel';
import { RegvarDecimalModel } from './RegvarDecimalModel';
import { RegvarIntegerModel } from './RegvarIntegerModel';
import { RegvarListModel } from './RegvarListModel';
import { RegvarStringModel } from './RegvarStringModel';
import { RegvarValueDomainModel } from './RegvarValueDomainModel';
import { RegvarResourceModel } from './RegvarResourceModel';
export function createRegvarModel(rv, shortname, regvarMetadata) {
    const { value, include, ...rvExtra } = rv;
    const data = {
        value: value,
        include: include,
        $extra: rvExtra,
        $rcc: {
            shortname: shortname,
            regvarMetadata: regvarMetadata
        }
    };
    switch(data.$rcc.regvarMetadata.dataType){
        case 'string':
            return new RegvarStringModel(data);
        case 'boolean':
            return new RegvarBooleanModel(data);
        case 'datetime':
            return new RegvarDatetimeModel(data);
        case 'decimal':
            return new RegvarDecimalModel(data);
        case 'integer':
            return new RegvarIntegerModel(data);
        case 'list':
            return new RegvarListModel(data);
        case 'valuedomain':
            return new RegvarValueDomainModel(data);
        case 'resource':
            return new RegvarResourceModel(data);
    }
    throw new Error(`Invalid data type: ${data.$rcc.regvarMetadata.dataType}.`);
}
